import { Commande } from "./Commande";
import { DTOCommandes } from "./DTO/DtoCommandes";

export class ReponseGetCommande {
    nbElement: number = 0;
    dtoCommandes: DTOCommandes[] = [];
}